module.exports = __webpack_public_path__ + "img/certificate4.84c67454.png";